<template>
 <!-- Summary Cards Row -->
 <v-row v-if="sparklines" dense>
      <v-col cols="12" sm="6" md="4">
        <v-skeleton-loader
          v-if="!dataLoaded"
          type="card"
          height="150"
        ></v-skeleton-loader>
        <TotalSparkCard
          v-else
          :label="t('total')"
          :count="totalItems"
          :show-sparkline="true"
          :sparkline-data="spark.totalItems.data"
          :sparkline-labels="spark.totalItems.labels"
          sparkline-color="primary"
          :show-percentage-change="true"
          :percentage-change="spark.totalItems.percentageChange"
        />
      </v-col>
      <v-col cols="12" sm="6" md="4">
        <v-skeleton-loader
          v-if="!dataLoaded"
          type="card"
          height="150"
        ></v-skeleton-loader>
        <TotalSparkCardWithSwitch
          v-else
          identifier="totalAssignedToYourTeams"
          :label="t('assignedToYourTeams')"
          :count="totalAssignedToYourTeams"
          @filter-change="emit('filterChange', $event)"
          :selected="filterByMyTeams"
          @update:selected="emit('update:filterByMyTeams', $event)"
          :show-sparkline="true"
          :sparkline-data="spark.totalAssignedToYourTeams.data"
          :sparkline-labels="spark.totalAssignedToYourTeams.labels"
          sparkline-color="primary"
          :show-percentage-change="true"
          :percentage-change="spark.totalAssignedToYourTeams.percentageChange"
        />
      </v-col>
      <v-col cols="12" sm="6" md="4">
        <v-skeleton-loader
          v-if="!dataLoaded"
          type="card"
          height="150"
        ></v-skeleton-loader>
        <TotalSparkCardWithSwitch
          v-else
          identifier="totalAssignedToYou"
          :label="t('assignedToYou')"
          :count="totalAssignedToYou"
          @filter-change="emit('filterChange', $event)"
          :selected="filterByMe"
          @update:selected="emit('update:filterByMe', $event)"
          :show-sparkline="true"
          :sparkline-data="spark.totalAssignedToYou.data"
          :sparkline-labels="spark.totalAssignedToYou.labels"
          sparkline-color="primary"
          :show-percentage-change="true"
          :percentage-change="spark.totalAssignedToYou.percentageChange"
        />
      </v-col>
 </v-row>
 <v-row v-else dense>
      <v-col cols="12" sm="6" md="3">
        <v-skeleton-loader
          v-if="!dataLoaded"
          type="card"
          height="150"
        ></v-skeleton-loader>
        <TotalCardWithSelect
          v-else
          :items="[t('totalItems'), t('totalOpenItems')]"
          :count="totalItems"
          :tooltip="showOpenItemsOnly ? t('totalOpenItemsToolTip') : ''"
          :modelValue="showOpenItemsOnly"
          @update:modelValue="emit('update:showOpenItemsOnly', $event)"
        />
      </v-col>
      <v-col cols="12" sm="6" md="3">
        <v-skeleton-loader
          v-if="!dataLoaded"
          type="card"
          height="150"
        ></v-skeleton-loader>
        <TotalCard
          v-else
          :label="t('totalSubItems')"
          :count="totalSubItems"
          :tooltip="t('totalSubItemsTooltip')"
        />
      </v-col>
      <v-col cols="12" sm="6" md="3">
        <v-skeleton-loader
          v-if="!dataLoaded"
          type="card"
          height="150"
        ></v-skeleton-loader>
        <TotalCardWithSwitch
          v-else
          identifier="totalAssignedToYourTeams"
          :label="t('assignedToYourTeams')"
          :count="totalAssignedToYourTeams"
          @filter-change="emit('filterChange', $event)"
          :selected="filterByMyTeams"
          @update:selected="emit('update:filterByMyTeams', $event)"
        />
      </v-col>
      <v-col cols="12" sm="6" md="3">
        <v-skeleton-loader
          v-if="!dataLoaded"
          type="card"
          height="150"
        ></v-skeleton-loader>
        <TotalCardWithSwitch
          v-else
          identifier="totalAssignedToYou"
          :label="t('assignedToYou')"
          :count="totalAssignedToYou"
          @filter-change="emit('filterChange', $event)"
          :selected="filterByMe"
          @update:selected="emit('update:filterByMe', $event)"
        />
      </v-col>
    </v-row>
</template>

<script src="./model.js"></script>
<style src="./style.css"></style>
